import React, {Component} from "react";
import {inject, observer} from "mobx-react";

@observer
class LoadingView extends Component {
    render() {

        const {rootStore} = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={(layerStore.getLayerLoadingView?'loading':'')}>
                <div className="inner">
                    <div className="loadingCircle">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoadingView;